<div class="flex justify-between items-center min-w-40">
    <div>
        <fa-icon
            class="cursor-pointer pr-2"
            [class]="isBookmarked() ? 'text-custom-orange' : 'text-outline-variant'"
            [icon]="['fas', 'star']"
            (click)="toggleIsBookmarked.emit()" />
        <span
            class="text-subtitle-1 text-on-background truncated-text"
            [matTooltip]="column().length > 19 ? column() : ''"
            >{{ column() }}</span
        >
    </div>
    @if (isBookmarked()) {
        <div>
            <input
                class="max-w-8"
                matInput
                step="1"
                type="number"
                [class.error]="hasError()"
                [max]="max"
                [min]="min"
                [ngModel]="order()"
                (ngModelChange)="changeOrder.emit($event !== '' ? +$event : null)" />
        </div>
    }
</div>
